import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Button } from "primereact/button";

const TIMEOUT_COUNT = 300;

function TimeoutWarning({ isVisible, closeTimeoutWarning, timeoutLogout }) {
  const [count, setCount] = useState(TIMEOUT_COUNT);
  const [timer, setTimer] = useState(true)
  useEffect(() => {
    let timeout;
    if (count === 0) {
      timeoutLogout();
    } else {
      timeout = setTimeout(() => {
        setCount(count - 1);
        var mins = Math.floor(count/60);
        let secs = count
        secs %= 60
        setTimer( ( (mins < 10) ? "" : "" ) + mins + ":" + ( (secs < 10) ? "0" : "" ) + secs);

      }, 1000);
    }
    return () => clearTimeout(timeout);
  });


  return (
    <ConfirmDialog
        group="headless"
        visible={isVisible}
        content={({ headerRef, contentRef, footerRef, hide }) => (
            <div className="flex flex-col p-5 border border-adg-gray shadow-md rounded bg-white">
                <h1 className="font-bold text-3xl block mt-4" ref={headerRef}>
                  Session Timeout Warning
                </h1>
                <p className="text-adg-gray-dark">You are being automatically logged out due to inactivity. </p>
                <p className="mb-0" ref={contentRef}>
                  You will be logged out in {TIMEOUT_COUNT /60 } minutes if don't extend your session.
                </p>
                <p>                  
                  Time remaining: { timer }
                </p>
                <div className="flex justify-end gap-2 mt-4" ref={footerRef}>
                    <Button
                        label={`Log Out`}
                        outlined
                        onClick={(event) => {
                            hide(event);
                            timeoutLogout();
                        }}
                        className=""
                    ></Button>
                    <Button
                        label="Stay Signed In"
                        onClick={(event) => {
                            hide(event);
                            closeTimeoutWarning();
                        }}
                        className=""
                    ></Button>
                </div>
            </div>
        )}
    />
  );
}

TimeoutWarning.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  closeTimeoutWarning: PropTypes.func.isRequired,
  timeoutLogout: PropTypes.func.isRequired,
};

export default React.memo(TimeoutWarning);
